export default "__VITE_ASSET__ClqnHI3m__"